import './style.scss'
import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AbsoluteContainer, AppLink, AppText, Button, CustomContainer, FixedContainer, GridContainer, Icon, ScreenContainer } from 'src/style'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import UserContext from 'src/provider/state-manager/userProvider'
import { TermsAndCondition } from 'src/component'
import LoginBgImg from 'src/assets/svg/login-bg-img-d2'
import { Features } from 'src/model'


export const OnboardingTypeD2 = () => {
    const navigate = useNavigate()
    const {setInfoProperty, info: {institutionData}} = useContext(AppInfoContext)
    const {user: {onboardingInput}, setUserProperty} = useContext(UserContext)
    const [isTermsAndconditions, setIsTermsAndConditions] = useState(false)
    const [appLogo, setAppLogo] = useState('')

    useEffect(() => {
        if (institutionData) setAppLogo(institutionData.logo)
    }, [institutionData?.logo])

    useEffect(() => {
        setInfoProperty('onboardingProcessStatus', {})
    }, [])

    function handleNext (type: string) {
        setInfoProperty('onboardingType', type)
        setUserProperty('onboardingInput', {...onboardingInput, isNewCustomer: type === 'new-user'})
        setIsTermsAndConditions(true)
    }

    return (
        <>
            <ScreenContainer 
                padding='0' bgColor='#F2FFFE'
                className='screen-container-bg-d2'
            >
                <FixedContainer 
                    top='50' tSizeUnit='%' left='75' rSizeUnit='%'
                    className='login-bg-img-d2'
                >
                    <LoginBgImg className='icon-component' />
                </FixedContainer>
                <GridContainer 
                    overflow='auto' minHeight='100' mnHUnit='%'
                    padding='3' width='48' bgColor='rgba(255, 255, 255, 0.95)'
                    shadow='0px 4px 4px 0px #00000040'
                    className='login-container'
                >
                    <AbsoluteContainer top='0' left='0' height='full' width='100' sizeUnit='%' bgColor='rgba(255, 255, 255, 0.95)' />
                    <CustomContainer width='37' className='login-content-container'>
                        <CustomContainer width='15.4' height='4' bottomMargin='3'>
                            { appLogo ? <Icon 
                                src={appLogo} className='app-logo-icon' noResize
                                onClick={() => navigate('/login')}
                            /> : null }
                        </CustomContainer>
                        <AppText textSize='3' fontWeight='800' fontFamily='Gilmer-Bold'>Do you have an Account with Us?</AppText>
                        <CustomContainer>
                            { institutionData.featureIDs?.includes(Features.EXISTING_CUSTOMER_ONBOARDING) &&
                                <Button 
                                    width='100' sizeUnit='%' topMargin='3' borderColor='#D0D5DD'
                                    hoverColor='#000000' bgColor='#ffffff' color='#344054'
                                    onClick={() => handleNext('existing-user')}
                                >
                                    Yes, I already Have an Account
                                </Button>
                            }
                            { institutionData.featureIDs?.includes(Features.NEW_CUSTOMER_ONBOARDING) &&
                                <Button 
                                    width='100' sizeUnit='%' topMargin='2.5' 
                                    borderColor='#0D968F' hoverBgColor='#0A756F' 
                                    hoverColor='#ffffff'
                                    onClick={() => handleNext('new-user')}
                                >
                                    No, I’m ready to Onboard
                                </Button>
                            }
                            <AppText topMargin='3.5' align='center'>
                                <AppLink 
                                    textSize='1.4' color='#070707' fontWeight='600' 
                                    decoration='none' hoverColor='#0A756F'
                                    onClick={() => navigate('/login')}
                                >
                                    Go Back to Login
                                </AppLink>
                            </AppText>
                        </CustomContainer>
                    </CustomContainer>
                </GridContainer>
            </ScreenContainer>
            { isTermsAndconditions &&
                <TermsAndCondition 
                    close={() => setIsTermsAndConditions(false)}
                />
            }
        </>
    )
}
